import type { Locale } from 'date-fns';
import { enUS, ja, ko, zhCN, zhTW } from 'date-fns/locale';
import { GetBookingInfoLanguageCodeEnum } from '@link/china-railway/services/types';

/**
 * Maps i18n language code to date-fns Locale object
 */
export function getDateFnsLocale(language: string): Locale {
  const localeMap: Record<string, Locale> = {
    en: enUS,
    ja: ja,
    ko: ko,
    zh: zhCN,
    zt: zhTW
  };

  return localeMap[language] || zhCN;
}

export function getLanguageCode(
  language: string
): GetBookingInfoLanguageCodeEnum {
  const languageMap = {
    en: GetBookingInfoLanguageCodeEnum.EnUs,
    ja: GetBookingInfoLanguageCodeEnum.JaJp,
    ko: GetBookingInfoLanguageCodeEnum.KoKr,
    zh: GetBookingInfoLanguageCodeEnum.ZhHans,
    zt: GetBookingInfoLanguageCodeEnum.ZhHant
  } as const;
  return (
    languageMap[language as keyof typeof languageMap] ||
    GetBookingInfoLanguageCodeEnum.ZhHans
  );
}
